"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _packet = require("./packet");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Program Map Tables (PMTs) contain information about programs. For each program, there is one PMT.
//
// While the MPEG-2 standard permits more than one PMT section to be transmitted on a single PID
// (Single Transport stream PID contains PMT information of more than one program),
// most MPEG-2 "users" such as ATSC and SCTE require each PMT to be transmitted on a separate PID that
// is not used for any other packets. The PMTs provide information on each program present in the
// transport stream, including the program_number, and list the elementary streams that comprise the
// described MPEG-2 program. There are also locations for optional descriptors that describe the
// entire MPEG-2 program, as well as an optional descriptor for each elementary stream.
//
// Each elementary stream is labeled with a stream_type value.
var PMT =
/*#__PURE__*/
function (_Packet) {
  _inherits(PMT, _Packet);

  function PMT(header, bitReader) {
    var _this;

    _classCallCheck(this, PMT);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PMT).call(this, header, bitReader));
    _this.objType = 'PMT';
    _this.programs = [];
    _this.ptrField = bitReader.readBits(8);

    if (_this.ptrField) {
      bitReader.readBits(_this.ptrField * 8);
    }

    _this.tableID = bitReader.readBits(8);
    var sectionSyntaxIndicator = bitReader.readBit();
    _this.privateBit = bitReader.readBit();
    bitReader.readBits(2); // reserved bits

    bitReader.readBits(2); // section length unused bits

    var sectionLength = bitReader.readBits(10);
    var stopBit = bitReader.currentBit() + sectionLength * 8;

    while (bitReader.currentBit() < stopBit) {
      var program = {
        tracks: []
      };
      program.id = bitReader.readBits(16);
      bitReader.readBits(2);
      program.versionNumber = bitReader.readBits(5);
      var currentNextIndicator = bitReader.readBit();
      var sectionNumber = bitReader.readBits(8);
      var lastSectionNumber = bitReader.readBits(8);
      var reserved = bitReader.readBits(3);
      program.pcrPID = bitReader.readBits(13);
      reserved = bitReader.readBits(4);
      var programInfoLengthUnusedBits = bitReader.readBits(2);
      var programInfoLength = bitReader.readBits(10);

      if (programInfoLength > 0) {
        var descriptor = {
          data: []
        };
        descriptor.tag = bitReader.readBits(8);
        var descriptorLength = bitReader.readBits(8);
        var descStopBit = bitReader.currentBit() + descriptorLength * 8;

        while (bitReader.currentBit() < descStopBit) {
          descriptor.data.push(bitReader.readBits(8));
        }

        program.descriptor = descriptor;
      }

      var esStopBit = stopBit - 32; // 32 bits for the CRC at the end

      while (bitReader.currentBit() < esStopBit) {
        var track = {};
        track.streamType = bitReader.readBits(8);
        bitReader.readBits(3);
        track.elementaryPID = bitReader.readBits(13);
        bitReader.readBits(4);
        bitReader.readBits(2);
        var esInfoLength = bitReader.readBits(10);
        var esInfo = [];

        var _esStopBit = bitReader.currentBit() + esInfoLength * 8;

        while (bitReader.currentBit() < _esStopBit) {
          esInfo.push(bitReader.readBits(8));
        }

        if (esInfo.length > 0) {
          track.esInfo = esInfo;
        }

        program.tracks.push(track);
      }

      var crc = bitReader.readBits(32);

      _this.programs.push(program);
    }

    return _this;
  }

  return PMT;
}(_packet.Packet);

var _default = PMT;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/pmt.js
// module id = 475
// module chunks = 0